// @ts-check
import { attrConfig as wId } from './w-id.js';
import { attrConfig as wDisplacedByCustomXml } from './w-displaced-by-custom-xml.js';

/**
 * All valid attributes for the <w:bookmarkEnd> element
 * @type {import('@translator').AttrConfig[]}
 */
export default [wId, wDisplacedByCustomXml];
